import Swiper, { Navigation, Pagination, A11y } from 'swiper';
import $ from 'jquery';

const slider = '.js-large-image-box__slider';
const sliderMainWrap = '.js-swiper-main-wrap';
const nextSlideNavEl = '.swiper-button-next';
const prevSlideNavEl = '.swiper-button-prev';
const slideNavBlock = '.swiper__navigate-block';
const pagination = '.swiper-pagination';

function toggleNavigationView($slider) {
  const swiperDisabledClass = 'swiper-button-disabled';
  const mainWrap = $slider.closest(sliderMainWrap);
  const navBlock = mainWrap.find(slideNavBlock);
  const prevButton = navBlock.find(prevSlideNavEl);
  const nextButton = navBlock.find(nextSlideNavEl);
  if (prevButton.hasClass(swiperDisabledClass) && nextButton.hasClass(swiperDisabledClass)) {
    navBlock.hide();
  } else {
    navBlock.show();
  }
}

function initSlider($slider) {
  const swiper = new Swiper($slider[0], {
    modules: [Navigation, Pagination, A11y],
    loop: true,
    init: false,
    freeMode: true,
    spaceBetween: 0,
    centeredSlides: false,
    slidesPerView: 1,
    keyboard: true,
    pagination: {
      el: pagination,
      clickable: true,
    },
    navigation: {
      nextEl: $slider.closest(sliderMainWrap).find(nextSlideNavEl)[0],
      prevEl: $slider.closest(sliderMainWrap).find(prevSlideNavEl)[0],
    },
    on: {
      transitionEnd: () => {
        $(document).trigger('slider-transition-end', {
          slider: this,
        });
      },
      resize: () => {
        toggleNavigationView($slider);
      },
      paginationRender: () => {
        $slider.find('.swiper-pagination-bullet').each(function (index) {
          const bullet = $(this);
          bullet.attr('data-slide-id', (index));
        });

        $slider.find('.swiper-pagination').each(() => {
          $slider.find('.swiper-pagination-bullet').attr('tabindex', 0);
          $slider.find('.swiper-pagination-bullet').on('keydown', function (event) {
            if (event.keyCode === 13) {
              const slideID = $(this).attr('data-slide-id');
              swiper.slideToLoop(slideID);
            }
          });
        });
      },
    },
    breakpoints: {
      768: {
        freeMode: true,
        slidesPerView: 1,
        spaceBetween: 0,
      },
      1024: {
        freeMode: false,
        allowTouchMove: false,
        slidesPerView: 1,
        spaceBetween: 0,
      },
      1380: {
        freeMode: false,
        allowTouchMove: false,
        slidesPerView: 1,
        spaceBetween: 0,
      },
    },
  });

  swiper.init();
  toggleNavigationView($slider);
}

$(document).ready(() => {
  if ($(slider).length) {
    $(slider).each(function () {
      initSlider($(this));
    });
  }
});
